import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";

import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";

import Widget from "components/widget/Widget";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";
import AdminDataService from "../../../services/admin.service";
import VotersDataService from "../../../services/voters.service";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import ColumnsTable from "../tables/components/ColumnsTable";

const Dashboard = () => {
  const [allData, setAllData] = useState([]);
  const [voters, setVoters] = useState(null);
  const [restaurants, setRestaurants] = useState(null);
  useEffect(()=> {
    getRestauRants();
    getCountVoters();
    getCountRestaurants();
  },[])

  const getRestauRants = async () => {
    try {
      const res = await AdminDataService.getAllRestaurant();
      if (res.data && res.data.status === "200") {
        setAllData(res.data.data);
      } else {
        toast.error("Something went wrong! Please try again later.");
      }
    } catch (err) {
      toast.error("Something went wrong! Please try again later.");
    }
  };

const getCountVoters = async () => {
    try {
      const res = await VotersDataService.getCountVoters();
      if (res.data && res.data.status === "200") {
        setVoters(res.data.data);
      } else {
        toast.error("Something went wrong! Please try again later.");
      }
    } catch (err) {
      toast.error("Something went wrong! Please try again later.");
    }
}

const getCountRestaurants = async () => {
    try {
      const res = await AdminDataService.getCountRestaurants();
      if (res.data && res.data.status === "200") {
        setRestaurants(res.data.data);
      } else {
        toast.error("Something went wrong! Please try again later.");
      }
    } catch (err) {
      toast.error("Something went wrong! Please try again later.");
    }
}
  const columns = [
    {
      Header: "NAME",
      accessor: "restaurant_name",
    },
    {
      Header: "PRODUCT",
      accessor: "drinks",
    },
    {
      Header: "TOTAL VOTES",
      accessor: "votes",
    },
    {
      Header: "POSITION",
      accessor: "position",
    },
  ];

  return (
    <div>
      {/* Card widget */}

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-2">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Combined Reviews"}
          subtitle={`${voters ? voters : "0"}`}
        />
        <Widget
          icon={<IoDocuments className="h-7 w-7" />}
          title={"Total Restaurant"}
          subtitle={`${restaurants ? restaurants : "0"}`}
        />
      </div>

      {/* Charts */}

      {/* <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div> */}

      {/* Tables & Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        {/* Check Table */}
        <div>
          {/* <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          /> */}
          <ColumnsTable
          columnsData={columns}
          tableData={allData.length > 0 && allData || []}
        />
        </div>

        {/* Traffic chart & Pie Chart */}

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-1">
          {/* <DailyTraffic /> */}
          <PieChartCard allData={allData.length > 0 && allData || []} />
        </div>

        {/* Complex Table , Task & Calendar */}

        {/* <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        /> */}

        {/* Task chart & Calendar */}

        
      </div>
    </div>
  );
};

export default Dashboard;
